import SponSlide from 'spon-slide'
import { h, Component } from 'preact' // eslint-disable-line

export default class ReactSlide extends Component {
	componentDidMount = () => {
		const { images } = this.props

		if (images.length > 1) {
			this.slide = new SponSlide(document.getElementById('slide-comp'), {
				loop: false,
				selector: '[data-slide-item]',
				activeClass: 'slide__item--current',
				dots: false,
				// nextButton: '.slide__btn--next',
				// previousButton: 'slide__btn--prev'
			})

			this.slide.init()

			console.log(this.slide);

			window.onkeyup = e => {
				switch (e.keyCode) {
					case 37:
						this.slide.prev()
						break
					case 39:
						this.slide.next()
						break
				}
			}
		}
	}

	render() {
		const { images } = this.props
		return (
			<div id="slide-comp">
				<ul className="r-list slide__wrap" data-ui="slide">
					{images.map((item, index) => (
						<li
							className={`slide__item slide__item--flex ${
								index === 0 ? 'slide__item--current' : ''
								}`}
							key={index}
							data-slide-item
						>
							<div className={`slide__img-container orientation--${item.orientation}`}>
								<img
									src={item.url}
									alt={''}
									className={`slide__img ${
										item.height > item.width ? 'slide__img--portrait' : 'slide__img--landscape'
										}`}
								/>
							</div>
						</li>
					))}
				</ul>
				{images.length > 1 && (
					<div className="slide__btns">
						<a
							key="a"
							className="slide__btn slide__btn--prev"
							href="#0"
							data-slide-prev
						>
							<i className="icon icon--ui-left-arrow">
								<svg>
									<use className="no-barba" xlinkHref="#ui-left-arrow" />
								</svg>
							</i>
						</a>
						<a
							key="b"
							className="slide__btn slide__btn--next"
							href="#1"
							data-slide-next
						>
							<i className="icon icon--ui-right-arrow">
								<svg>
									<use className="no-barba" xlinkHref="#ui-right-arrow" />
								</svg>
							</i>
						</a>
					</div>
				)}
			</div>
		)
	}
}
